import { Plane } from 'lucide-react';
import { formatDate } from 'shared_items/formatConventions';

const CardTransportSummary = ({ transport, onClick }) => {
  const when =
    transport.departure_date
      ? `${formatDate(transport.departure_date)}${
          transport.departure_time ? ` · ${transport.departure_time}` : ''
        }`
      : 'No departure';

  const route = [transport.origin, transport.destination].filter(Boolean).join(' → ');

  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-left bg-white border border-gray-200 rounded-xl p-3 shadow-sm hover:bg-gray-50 hover:border-gray-300 transition flex gap-3"
    >
      <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-700 flex items-center justify-center flex-shrink-0">
        <Plane className="h-5 w-5" strokeWidth={2} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h4 className="text-sm font-semibold text-gray-900 truncate">
            {transport.description || transport.carrier || transport.mode || 'Transport'}
          </h4>
          {transport.status ? (
            <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 flex-shrink-0">
              {transport.status}
            </span>
          ) : null}
        </div>
        <p className="text-xs text-gray-500 mt-0.5">{when}</p>
        {route && <p className="text-xs text-gray-400 mt-0.5 truncate">{route}</p>}
      </div>
    </button>
  );
};

export default CardTransportSummary;
